import { create } from 'zustand';

/**
 * 회의록 알림 ★ **tick** — bump 패턴 (`approvalStore` · `notificationStore` 와 같은 꼴).
 *
 * ## ⭐ 무엇을 ★ 알리나 — ⇒ 「⭐ 무언가 바뀌었다」 **하나**다
 *
 * 서버(`voice-finalize.ts`)가 회의록을 만들거나(전사 완료) 요약을 실으면(요약 완료)
 * `enqueueNotification` 을 ★ 한 번 부르고 ⇒ 그것이 ⭐ `/sse/me` 로 온다.
 * ⇒ ⛔ 그런데 ★ 그 알림에는 ⭐ **어느 회의록인지가 «없다»** — `sourceId` 가 `null` 이다.
 *   까닭: 그 칸이 `BigInt?` 인데 회의록 id 는 ★ **uuid 문자열**이고, 담을 다른 칸도 없다
 *   (`prisma/schema.prisma` 의 `model Notification` — 칸 열뿐. 칸을 더하는 것은 ⛔ 마이그다).
 * ⇒ ⇒ ★ 그래서 ⭐ 이 store 는 **id 를 안 담는다**. ⇒ ★ 「무엇이」는 ⭐ **화면이 스스로 본다** —
 *   제 것을 다시 읽어 ★ 바뀌었나를 본다(`AiMinutesPage` 의 그 효과).
 * ⇒ ⇒ ⇒ ⭐ 그러면 ★ id 가 없어도 ⇒ ⛔ 「엉뚱한 회의록에 띠」가 ★ 안 생긴다 — 내 것이 안 바뀌면
 *   띠가 안 뜬다. (⚠ 앱도 같은 길을 골랐다 — `aos/.../MinutesResync.kt` 의 A-1a 주석)
 *
 * ## ⛔ `notificationStore.lastNotificationBump` 를 ★ 왜 안 쓰나 — ⇒ ⭐ 재 봤다
 *
 * 그 값은 `useLayoutNotifications` 가 ★ **채팅을 뺀 모든 알림**에 올린다
 * (`incrementUnread()` ⇒ `lastNotificationBump + 1`). ⇒ ⛔ 그것에 매달면 ★ 일정·게시판·결재
 * 알림에도 ⭐ 회의록 목록을 다시 읽는다 — ★ 헛조회다.
 * ⇒ ✅ 그래서 ⭐ **회의록만의 tick** 을 따로 둔다. 가름은 `lib/notification-source.ts` 의
 *   `isMinutesNotification` ★ 한 곳이고, 그것이 ⭐ `source` 와 `type` 을 **둘 다** 본다.
 *
 * ## ⚠ `approvalStore` 머리말을 ★ 믿지 말 것 (2026-10-08 실측)
 *
 * 그 파일은 「TopBar 의 `useSSE` 가 `bumpApprovalStatus()` 를 부른다」고 적고 있는데
 * ⇒ ⛔ **실제로 부르는 곳은 ★ 사용자가 직접 올릴 때 한 곳뿐**이다(`ApprovalNewPage.tsx`) —
 *   ⇒ ★ SSE 배선은 ⭐ **0건**이다. ⇒ ⚠ 그 주석을 보고 「그 길이 이미 있다」고 읽으면 틀린다.
 *   ⇒ ✅ 베낀 것은 ★ **꼴**(27줄)뿐이고, ⭐ 배선은 이 판에서 ★ 새로 깐다.
 */
interface MinutesNotifyState {
  /** 회의록 알림이 ★ 올 때마다 ＋1. ⛔ 0 은 「아직 안 왔다」다 — ⇒ 화면이 그것으로 첫 판을 가린다. */
  minutesNotifyTick: number;
  bumpMinutesNotify: () => void;
  reset: () => void;
}

export const useMinutesNotifyStore = create<MinutesNotifyState>((set) => ({
  minutesNotifyTick: 0,
  bumpMinutesNotify: () => set((s) => ({ minutesNotifyTick: s.minutesNotifyTick + 1 })),
  reset: () => set({ minutesNotifyTick: 0 }),
}));
